var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGReport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 19,
    viewBox: "0 0 17 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.5625 2.0625L3.25 0.75V13H1.5C0.8 13 0.625 13.5833 0.625 13.875V15.625C0.625 17.725 2.375 18.25 3.25 18.25H13.3125C16.1125 18.25 16.5208 16.2083 16.375 15.1875V0.75L15.0625 2.0625L13.75 0.75L12.4375 2.0625L11.125 0.75L9.8125 2.0625L8.5 0.75L7.1875 2.0625L5.875 0.75L4.5625 2.0625Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGReport);
export default __webpack_public_path__ + "static/media/g_report.cc39c148426bcb4d626923785e7dd7cf.svg";
export { ForwardRef as ReactComponent };